import { render, staticRenderFns } from "./venueone.vue?vue&type=template&id=352cdf7a&scoped=true&"
import script from "./venueone.vue?vue&type=script&lang=js&"
export * from "./venueone.vue?vue&type=script&lang=js&"
import style0 from "./venueone.vue?vue&type=style&index=0&id=352cdf7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352cdf7a",
  null
  
)

export default component.exports